// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Suggestions_wrap__1IPuz","infoText":"Suggestions_infoText__3U3y6","expandSearch":"Suggestions_expandSearch__2kjGv"};